// @flow

import React, { Component } from 'react';
import _ from 'lodash'
import I18n from 'PMT/i18n/I18n';

// -- constants
import Events from 'constants/Events';
import RoutingEnum from 'constants/RoutingEnum';

import Listener from 'PMT/flux/Listener';

import ViewUtils from 'PMT/utils/ViewUtils';

// -- actions
import RouteAction from 'actions/RouteAction';
import RestaurantMenuAction from 'actions/RestaurantMenuAction';

// -- stores
import SessionStore from 'stores/SessionStore';
import RestaurantMenuStore from 'stores/RestaurantMenuStore';
import RestaurantStore from 'stores/RestaurantStore';

// -- entities
import Restaurant from 'PMT/entities/Restaurant';
import RestaurantMenu from 'PMT/entities/menu/RestaurantMenu';
import ProductOption from 'PMT/entities/menu/ProductOption';

// -- components
import RestaurantMenuTabs from "pages/menu/RestaurantMenuTabs";
import AbstractComponent from 'components/AbstractComponent';
import Ariane from 'PMT/components/Ariane';
import ProductOptionDetailView from './ProductOptionDetailView';

class ProductOptionDetailPage extends AbstractComponent {

  state = {
    restaurantMenu: RestaurantMenuStore.getRestaurantMenu(),
    restaurant: RestaurantStore.getRestaurant(),

    productOption: null
  };

  componentDidMount() {
    RestaurantMenuStore.addListeners(this.restaurantMenuStoreListeners);

    if (_.isNull(this.state.restaurantMenu)) {
      RestaurantMenuAction.loadRestaurantMenu();
    } else {
      this.loadProductOption();
    }
  }

  componentWillUnmount() {
    RestaurantMenuStore.removeListeners(this.restaurantMenuStoreListeners);
  }

  get restaurantMenuStoreListeners(): Array<Listener> {
    return [
      new Listener(Events.ON_LOADING_RESTAURANT_MENU_SUCCESS, this.onChange),
      // new Listener(Events.ON_LOADING_RESTAURANT_MENU_ERROR, this.onError),
      new Listener(Events.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onMenuUpdated),
      // new Listener(Events.ON_UPDATE_RESTAURANT_MENU_ERROR, this.onError),
      new Listener(Events.ON_UPDATE_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS, this.onMenuUpdated),
      // new Listener(Events.ON_UPDATE_RESTAURANT_MENU_PRODUCT_OPTION_ERROR, this.onError)
    ];
  }

  get productOption(): ProductOption {
    return this.state.productOption;
  }

  get restaurantMenu():RestaurantMenu {
    return this.state.restaurantMenu;
  }

  get restaurant(): Restaurant {
    return this.state.restaurant;
  }


  getProductOptionOnRestaurantMenu(restaurantMenu) {
    const productOptionId = this.props.match.params.productOptionId;
    const productOption:ProductOption = restaurantMenu.getProductOptionWithId(productOptionId);

    return productOption;
  }

  loadProductOption() {
    const productOption: ProductOption = this.getProductOptionOnRestaurantMenu(this.state.restaurantMenu);

    this.setState({
      productOption,
      loading: false
    });
  }

  // -- Event functions

  onChange = () => {
    const restaurantMenu:RestaurantMenu = RestaurantMenuStore.getRestaurantMenu();
    const productOption:ProductOption = this.getProductOptionOnRestaurantMenu(restaurantMenu);

    this.setState({
      restaurantMenu,
      productOption,
      loading: false
    });
  };

  onMenuUpdated = () => {
    const restaurantMenu: RestaurantMenu = RestaurantMenuStore.getRestaurantMenu();
    const productOption: ProductOption = this.getProductOptionOnRestaurantMenu(restaurantMenu);

    this.setState({
      restaurantMenu,
      productOption,
      loading: false
    });
  };

  onError = () => {
    // TODO: onError
  };

  //
  // Form events
  //

  onUpdate = (productOption: ProductOption, image: ?DataUri = null) => {
    this.showLoading();
    const imageFile = _.isNull(image) ? null : ViewUtils.dataUriToFile(image);
    RestaurantMenuAction.saveProductOption(productOption, imageFile);
  };

  //
  // renderers
  //

  renderBody() {
    if (_.isNull(this.productOption)) {
      return this.renderOnLoadingContent();
    }

    return (
      <ProductOptionDetailView
        productOption={this.productOption}
        restaurantMenu={this.restaurantMenu}
        onUpdate={this.onUpdate}
        currencyCode={this.restaurant.currency}
      />
    );
  }

  render() {
    const arianeIcon = 'fa-shopping-cart';

    const arianeDetails = [
      {
        name: I18n.tr('menu.order'),
        link: null
      },
      {
        name: I18n.tr('menu.order.restaurant_menu'),
        link: RoutingEnum.RESTAURANT_MENU,
        query: {
          tab: RestaurantMenuTabs.CATEGORIES
        }
      },
      {
        name: I18n.tr('menu.order.restaurant_menu.options'),
        link: RoutingEnum.RESTAURANT_MENU,
        query: {
          tab: RestaurantMenuTabs.OPTIONS
        }
      },
      {
        name: !_.isNull(this.productOption) ? this.productOption.name : '',
        link: null
      }
    ];

    return (
      <div className="product_option_detail_page">
        <Ariane icon={arianeIcon} details={arianeDetails}/>

        {this.renderBody()}
        {this.renderLoading()}
      </div>
    );
  }

}

export default ProductOptionDetailPage;
